import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import robustPng2x from './assets/RobustMarketingAppstore@2x.png'
import robustWebp from './assets/RobustMarketingAppstore.webp'
import robustWebp2x from './assets/RobustMarketingAppstore@2x.webp'

const RobustMarketingAppstoreImage = () => {
  return (
    <picture>
      <source type="image/webp" srcSet={`${robustWebp}, ${robustWebp2x} 2x`} />
      <StyledImage src={robustPng2x} alt="Robust" width="640" height="417" loading="lazy" />
    </picture>
  )
}

export default RobustMarketingAppstoreImage

const StyledImage = styled(Image)`
  position: absolute;
  top: 0;
  left: 50%;
  width: 140%;
  max-width: 407px;
  height: auto;
  transform: translate(-50%, 0%);
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 831px;
  }
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    max-width: 731px;
  }
`
